import Swiper, { Autoplay } from 'swiper';

export default {
  init() {
  
    Swiper.use([Autoplay]);

    /**************************************************************
    -> Publication Swiper instance
    **************************************************************/
    function locationsSwiper() {
      new Swiper('.locations .swiper-container', {
        spaceBetween: 20,
        slidesPerView: 'auto',
        autoplay: {
           delay: 5000,
        },
        breakpoints: {
            769: {
              slidesPerView: 3,
            },
         },
      })

    }

    locationsSwiper()

    function fadeinHeroImages() {
      const images = Array.from(document.querySelectorAll('.fadein-image'))
      let index = 0;

      setInterval( () => {
        images.forEach( el => {
          console.log(el)
          el.classList.add('opacity-0')
        })

        images[index].classList.remove('opacity-0')
        index++;

        if(index == images.length) index = 0;
      }, 7000);
    }

    fadeinHeroImages()

    function fadeinDiscoverImages() {
      const images = Array.from(document.querySelectorAll('.fadein-discover-image'))
      let index = 0;

      setInterval( () => {
        images.forEach( el => {
          console.log(el)
          el.classList.add('opacity-0')
        })

        images[index].classList.remove('opacity-0')
        index++;

        if(index == images.length) index = 0;
      }, 5000);
    }

    fadeinDiscoverImages()

  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/template-home.js